import React, { useEffect, useMemo, useState } from 'react'
// import MultistepForm from '../components/multistep-form/MultistepForm';

function capitalizeWords(string) {
    return string.replace(/\b\w/g, (match) => match.toUpperCase());
}

const Test = () => {
    const listingTypes = ["boat", "license", "package", "seafood"];
    const [currentListingType, setCurrentListingType] = useState("");

    const SelectListingType = useMemo(() => {
        return <select onChange={(e) => setCurrentListingType(e.target.value)}>
            <option value={""}>-- Please select --</option>
            {listingTypes.map((type) =>
                <option value={type}>{capitalizeWords(type)}</option>
            )}
        </select>
    }, []);

    if (currentListingType != "") {
        // return <MultistepForm listingType={currentListingType} />
    }

    else {
        return SelectListingType;
    }
}

export default Test